import { render } from "./Banks.vue?vue&type=template&id=5cb4134b&scoped=true"
import script from "./Banks.vue?vue&type=script&lang=js"
export * from "./Banks.vue?vue&type=script&lang=js"

import "./Banks.vue?vue&type=style&index=0&id=5cb4134b&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5cb4134b"]])

export default __exports__